import { asPage } from 'src/components/hoc/asPage'
import { MyPage } from 'src/compositions/MyPage'

export default asPage(MyPage, { pageTitle: 'マイページ' })
